import React from 'react';

import { withModifyMutation } from '../../../common/containers/helpersDetailContainer';
import AddressForm from './AddressForm';

const AddressDetail = ({ data, modifyItem }) => {
	return (
		<AddressForm data={data} onChange={modifyItem} />
	);
};

export default withModifyMutation(AddressDetail);
